import React from "react";
import Input from "../../input";
import styles from "../searchFilter.scss";

export default function SearchFilterInput({ searchType, onSearchValueChange, searchValue, searchTypeOptions, placeholder, onSearchClick, onEnter, errors, touched  }) {
    const validationType = searchType ? searchType.validation : "text";
    const onChange = (value) => {
        if (searchType && (value === "" || new RegExp(searchType.regex).test(value))) {
            onSearchValueChange(value);
        }
    };

    const onKeyDown = (event) => {
        if (typeof onEnter === 'function' && event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            onEnter();
        }
    }

    return (
        <div className={styles.searchwrap}>
            <Input
                value={searchValue}
                onChange={onChange}
                disabled={searchTypeOptions.length === 0 && !searchType}
                type={validationType}
                placeholder={placeholder}
                label=""
                required
                onKeyDown={onKeyDown}
                errors={errors}
                touched={touched}
            />
            <i className={`material-icons ${styles.searchiconbox}`} disabled={!(searchValue?.length > 0 || onSearchClick)} onClick={onSearchClick}>
                search
            </i>
        </div>
    );
}
